import type { ErrorType } from '~/data/ErrorRecord';
import type { TagCategory } from './Tag';

export interface TagState {
  isLoading: boolean;
  isEditing: boolean;
  error?: ErrorType;
  tagActionError?: ErrorType;
  errorModalTitle?: string;
  availableTagCategories?: TagCategory[];
}

export const initialTagState: TagState = {
  isLoading: false,
  isEditing: false,
};
